define([
	'internal_util/Util',
	'model/Error',
	'model/ErrorType',
	'amdi18n-loader?!service/nls/FileService_strings',
	'lib/jquery'
], function (
	Util,
	Error,
	ErrorType,
	Strings,
	jQuery
) {
	'use strict';

	/**
	 * FileService class
	 */
	return new function () {
		var _downloadServletURL = 'download',
			_localDownloadSupported = (typeof (document.createElement('a')).download !== 'undefined' && window.Blob),
			_localUploadSupported = (window.File && window.FileReader && window.FileList && window.Blob);


		// public methods

		this.download = function (fileName, fileData) {
			var element;

			if (_localDownloadSupported) {
				element = document.createElement('a');
				element.href = window.URL.createObjectURL(new window.Blob(["\ufeff", fileData]));
				element.download = fileName;

				document.body.appendChild(element);
				element.click();
				document.body.removeChild(element);
			} else {
				element = jQuery('<form>', {
						'action' : _downloadServletURL,
						'method' : 'POST',
						'target' : '_top'
					}).append(jQuery('<input>', {
						'name': 'file_name',
						'value': fileName,
						'type': 'hidden'
					})).append(jQuery('<input>', {
						'name': 'file_data',
						'value': fileData,
						'type': 'hidden'
					}));

				document.body.appendChild(element[0]);
				element.submit();
				document.body.removeChild(element[0]);
			}
		};

		this.upload = function (callbacks, errorCallbacks) {
			var fileInput;

			if (!_localUploadSupported) {
				Util.callCallbacks(errorCallbacks, new Error(ErrorType.RECOVERABLE, Strings.not_supported));
				return;
			}

			jQuery('body').children('#skIdS_file-chooser').remove();

			//fileInput = jQuery('<input type="file" accept="text/plain" style="visibility: hidden;"/>');
			fileInput = jQuery('<input id="skIdS_file-chooser" type="file" style="visibility: hidden;"/>');

			fileInput.on('change', function (event) {
				var fileReader = new window.FileReader();

				fileReader.onload = function (event) {
					Util.callCallbacks(callbacks, event.target.result);
				};

				fileReader.readAsText(event.target.files[0]);
			});

			fileInput.appendTo('body');
			fileInput.click();
		};
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/service/FileService.js
// module id = 71
// module chunks = 4